/**
 * Because of IE 11 and old androids we are increasing our bundles size
 */
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/map';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/set-prototype-of';
import 'core-js/fn/promise';
import 'core-js/fn/regexp';
import 'core-js/fn/set';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/string/pad-start';
import 'core-js/fn/string/repeat';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/weak-map';
